import { z } from 'zod';

/** What the `varchar` holds. Sixty is a name and a relationship, not a note. */
export const GUARDIAN_LABEL_MAX = 60;

/**
 * What one side calls the other — "أبي", "أخي محمد", "ابنتي فاطمة".
 *
 * **Both sides write one, and neither reads the other's.** The ward names her
 * wali when she issues the code; the guardian names his ward when he redeems it.
 * That symmetry is not decoration — it is what lets a guardian holding three
 * wards tell them apart without this feature reading a single profile answer.
 * The alternative was to draw the ward through `ProfileVisibilityResolver`, which
 * would make a guardian a new viewer *context* in the visibility policy (N18) —
 * a far larger decision, and one this phase does not need to take.
 *
 * It is private to its author for the same reason it is useful: a label is how
 * somebody thinks of a person, and "أبي" is a fact she chose to record for
 * herself, not a fact about him that he is owed.
 *
 * **Untranslated** (N5 does not apply): it is a person's own words about a
 * specific human being, not operator content, so there is nothing to translate
 * it *into*.
 *
 * `.trim()` runs before `.min(1)`, so a box holding only spaces is a **blank
 * required field** rather than a one-character label — the shape P22b1 recorded
 * after a `.trim().min(1)` turned an empty optional box into a refusal.
 */
export const GuardianLabelSchema = z.string().trim().min(1).max(GUARDIAN_LABEL_MAX);
